import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class Authorizer extends Component {
  constructor(props) {
    super(props);
    this.handleAuthorize = this.handleAuthorize.bind(this);
  }

  handleAuthorize() {
    const {orders} = this.props;
    const workElement = orders[0];
    this.props.authorizeProviderOrder({
      'orderCode': workElement.orderCode,
      'emailUserRequest': workElement.emailUserRequest,
      'providerName': workElement.providerName,
      'providerCode': workElement.providerCode,
    });
  }

  render() {
    return (
      <Button primary content='AUTORIZAR' onClick={this.handleAuthorize} />
    );
  }
}

const {
  authorizeProviderOrder,
} = Actions;

export default connect(null, {
  authorizeProviderOrder,
})(Authorizer);
